import type { TopicItem } from "@/types";

export const topicList: TopicItem[] = [
  {
    id: "t1",
    title: "治愈日常精选",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20anime%20illustration%20of%20a%20sunlit%20window%20seat%20with%20a%20cup%20of%20tea%20and%20a%20cat%20napping%2C%20flat%20cel%20shading%2C%20soft%20green%20and%20cream%20palette%2C%20clean%20warm%20background%2C%20healing%20collection%20cover%20style&width=640&height=420&seq=topic-01&orientation=landscape",
    intro: "收录节奏舒缓、氛围温暖的治愈系作品，适合下饭与放松心情。",
  },
  {
    id: "t2",
    title: "热血冒险合集",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20anime%20illustration%20of%20a%20hero%20charging%20forward%20with%20energy%20auras%20and%20clashing%20light%2C%20flat%20cel%20shading%2C%20vivid%20green%20and%20orange%20palette%2C%20clean%20dynamic%20background%2C%20action%20collection%20cover%20style&width=640&height=420&seq=topic-02&orientation=landscape",
    intro: "从机甲到奇幻，一口气看完成长与战斗交织的爽快故事。",
  },
  {
    id: "t3",
    title: "悬疑推理专场",
    cover:
      "https://readdy.ai/api/search-image?query=Atmospheric%20anime%20illustration%20of%20a%20mysterious%20closed%20door%20with%20glowing%20clues%20and%20floating%20documents%2C%20flat%20cel%20shading%2C%20deep%20teal%20and%20amber%20palette%2C%20clean%20moody%20background%2C%20mystery%20collection%20cover%20style&width=640&height=420&seq=topic-03&orientation=landscape",
    intro: "层层反转、线索暗藏，为喜欢动脑的你准备的推理片单。",
  },
];